import 'react-slideshow-image/dist/styles.css'
import React from 'react';
import { Slide } from 'react-slideshow-image'


const slideImages = [
  'assets/img/slide_1.jpg',
  'assets/img/slide_2.jpg',
  'assets/img/slide_3.png',
  'assets/img/slide_4.jpg',
  'assets/img/slide_5.jpg',
];

const Slideshow = () => {
  return (
    <div>
      <Slide easing="ease">

        <div className="each-slide">
          <div style={{ 'backgroundImage': `url(${slideImages[0]})` }}>

          </div>
        </div>
        <div className="each-slide">
          <div style={{ 'backgroundImage': `url(${slideImages[1]})` }}>

          </div>

        </div>
        <div className="each-slide">
          <div style={{ 'backgroundImage': `url(${slideImages[2]})` }}>

          </div>

        </div>

      </Slide>
    </div>
  )
};

export default Slideshow;